import { render, staticRenderFns } from "./WaiBuGongShi3.vue?vue&type=template&id=836656ae&scoped=true&"
import script from "./WaiBuGongShi3.vue?vue&type=script&lang=js&"
export * from "./WaiBuGongShi3.vue?vue&type=script&lang=js&"
import style0 from "./WaiBuGongShi3.vue?vue&type=style&index=0&id=836656ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836656ae",
  null
  
)

export default component.exports